import AssignForm from '../AssignForm/AssignForm';

import { useEffect, useRef, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingBtn from '../../../components/LoadingBtn/LoadingBtn';
import api from '../../../api/Api';


function AssignEdit() {
  const { identy } = useParams();
  const navigate = useNavigate();
  const [assign, setAssign] = useState(null);
  const [loading, setLoading] = useState(false);
  const formRef = useRef();

  useEffect(() => {
    api.get(`/api/assignments/${identy}`)
      .then((res) => setAssign(res.data.response),
    console.log("assign inside",assign

    )
    
    )
      .catch(err => console.error(err));
  }, [identy]);

  console.log("assign out",assign);
  
  const handleEdit = (updatedAsset) => {
    setLoading(true);
    // console.log("Submitting payload:", updatedAsset);
    api.put(`/api/assignments/${identy}`, updatedAsset)
      .then(() => {
        toast.success("Assign Edit Succesfully");
        setTimeout(() => navigate(`/assignments/${identy}`), 1000);
      })
      .catch(err => console.error(err));
  };

  if (!assign) return <p>Loading...</p>;


  return (
    <>
      {/* <ToastContainer position="bottom-right" autoClose={3000} /> */}
      <div className='d-flex justify-content-between mt-3'>
        <Link to={`/assignments/${identy}`} className="btn btn-secondary mb-3">← Back</Link>
        <h3 className='text-center mt-3'>Edit Assignment</h3>
        <div>
          <LoadingBtn
            type="submit"
            text="Update"
            loading={loading}
            disabled={loading}
            onClick={() => formRef.current.submitForm()}
          />
        </div>
      </div>
      <div className="container" style={{ width: "900px", height: '450px', overflowY: 'auto' }}>
        <AssignForm
        ref={formRef}
          initialData={assign}
          readOnlyFields={["employeeId", "assetId", "assignStatus"]}
          onSubmit={handleEdit}
          isEdit={true}
        />
      </div >



    </>
  );
}

export default AssignEdit;
